import * as OmValidationMessageHelper from '../helpers/validation-message-helper.js';
import ReferenceData from '../../refData/reference-data.js';

export function validateBranchCode(value, { required = true, subject = 'Branch code', retainSubjectCase } = {}) {
    
    if (!value && required) {
        return OmValidationMessageHelper.getRequiredMessage(subject, retainSubjectCase);
    }

    if (!value && !required) {
        return null;
    }

    const invalidMsg = OmValidationMessageHelper.getInvalidMessage(subject, retainSubjectCase);

    if (!ReferenceData.branchCodes.includes(value)) {
        return invalidMsg;
    }

    return null;
}
